import "./WebPortfolio.css";
import React from "react";
import { Container, Row, Col } from "react-bootstrap/";
import AUCCI from "../images/ac2.png";
import Shringar from "../images/shringar_product.png";
import SneakerSeek from "../images/sneak.png";
import { useInView } from "react-intersection-observer";

function WebPortfolio() {
  const { ref: portfolioRef, inView: portfolioVisible } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const webDesigns = [
    {
      title: "Shringar",
      image: Shringar,
      link: "https://shringar.beauty",
    },
    {
      title: "SneakerSeek",
      image: SneakerSeek,
      link: "https://github.com/DG-20/SneakerSeek",
    },
    {
      title: "AUCCI",
      image: AUCCI,
      link: "https://github.com/ttylong/SENG401Project",
    },
  ];

  return (
    <Container fluid className="webPortfolioSection py-5" id="web-portfolio" ref={portfolioRef}>
      <Container className={`${portfolioVisible ? "fade-in-up" : "opacity-0"}`}>
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Featured Web Designs</h2>
          <div className="titleHr" />
          <p className="section-subtitle">
            Modern web applications and custom front-end user experiences. Explore more on my{" "}
            <a href="https://github.com/DG-20" target="_blank" rel="noreferrer" className="IEEElink">
              GitHub Profile
            </a>
            .
          </p>
        </div>

        <Row className="g-4 justify-content-center">
          {webDesigns.map((design) => (
            <Col xs={12} md={6} lg={4} key={design.title}>
              <a href={design.link} target="_blank" rel="noreferrer" className="webCardLink">
                <div className="glass-card webProjectCard h-100 p-3">
                  <div className="webProjectImgContainer mb-3">
                    <img loading="lazy" src={design.image} alt={design.title} className="img-fluid worksImg" />
                    <div className="webImgOverlay">
                      <span className="webExploreBtn">View Project &rarr;</span>
                    </div>
                  </div>
                </div>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default WebPortfolio;
